<main class="service-update">
  <section class="service-update__panel" aria-labelledby="service-update-title">
    <header class="service-update__header">
      <img
        src="/ng1/www/img/new/header/nathan-toeic.svg"
        alt="Nathan TOEIC"
        width="181"
        height="87"
      >
    </header>

    <div class="service-update__content">
      <p class="service-update__label">Information importante</p>
      <h1 id="service-update-title">Nathan TOEIC : information importante</h1>

      <div class="service-update__message">
        <p class="service-update__lead">L’offre Nathan TOEIC évolue.</p>

        <p>
          Cette plateforme sous sa forme actuelle n’est plus ouverte aux nouvelles
          activations ni aux nouvelles souscriptions.
        </p>

        <p>
          Si vous disposez déjà d’une licence active, votre accès reste disponible
          jusqu’à son terme.
        </p>

        <p>
          Pour toute question relative à votre accès, à l’utilisation de votre code
          ou à la transition en cours, vous pouvez contacter le support Nathan à
          l’adresse suivante&nbsp;:
        </p>

        <p class="service-update__support">
          <a href="mailto:entrainementlangues@nathan.fr">
            entrainementlangues@nathan.fr
          </a>
        </p>
      </div>
    </div>
  </section>
</main>
